import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenerateReportComponent } from './generate-report.component';
import { CustomDatePickerModule } from "../../../../shared/components/custom-date-picker/custom-date-picker.module";
import { CustomDropdownModule } from "../../../../shared/components/custom-dropdown/custom-dropdown.module";
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';



@NgModule({
    declarations: [
        GenerateReportComponent
    ],
    exports: [
        GenerateReportComponent
    ],
    imports: [
        CommonModule,
        CustomDatePickerModule,
        CustomDropdownModule,
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        MatPaginatorModule
    ]
})
export class GenerateReportModule { }
